import { render } from "./IconWorld.vue?vue&type=template&id=763559a7"
import script from "./IconWorld.vue?vue&type=script&lang=js"
export * from "./IconWorld.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__